/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconButtonMenuArrowLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 16 16">
    <g>
    <g>
        <path d="M8.6,12.4l7.1-7.1C15.9,5.2,16,4.9,16,4.7c0-0.2-0.1-0.5-0.3-0.6l-0.5-0.5c-0.3-0.3-0.9-0.3-1.2,0l-6,6l-6-6 C1.9,3.4,1.6,3.3,1.4,3.3c-0.2,0-0.5,0.1-0.6,0.3L0.3,4.1C0.1,4.2,0,4.5,0,4.7s0.1,0.5,0.3,0.6l7.1,7.1c0.2,0.2,0.4,0.3,0.6,0.3 C8.2,12.7,8.5,12.6,8.6,12.4z" />
    </g>
</g>
  </Icon>
);
};

IconButtonMenuArrowLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDE2IDE2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxNiAxNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnPgoJCTxwYXRoIGQ9Ik04LjYsMTIuNGw3LjEtNy4xQzE1LjksNS4yLDE2LDQuOSwxNiw0LjdjMC0wLjItMC4xLTAuNS0wLjMtMC42bC0wLjUtMC41Yy0wLjMtMC4zLTAuOS0wLjMtMS4yLDBsLTYsNmwtNi02IEMxLjksMy40LDEuNiwzLjMsMS40LDMuM2MtMC4yLDAtMC41LDAuMS0wLjYsMC4zTDAuMyw0LjFDMC4xLDQuMiwwLDQuNSwwLDQuN3MwLjEsMC41LDAuMywwLjZsNy4xLDcuMWMwLjIsMC4yLDAuNCwwLjMsMC42LDAuMyBDOC4yLDEyLjcsOC41LDEyLjYsOC42LDEyLjR6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+";
IconButtonMenuArrowLineComponent.Content = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
<g>
	<g>
		<path d="M8.6,12.4l7.1-7.1C15.9,5.2,16,4.9,16,4.7c0-0.2-0.1-0.5-0.3-0.6l-0.5-0.5c-0.3-0.3-0.9-0.3-1.2,0l-6,6l-6-6 C1.9,3.4,1.6,3.3,1.4,3.3c-0.2,0-0.5,0.1-0.6,0.3L0.3,4.1C0.1,4.2,0,4.5,0,4.7s0.1,0.5,0.3,0.6l7.1,7.1c0.2,0.2,0.4,0.3,0.6,0.3 C8.2,12.7,8.5,12.6,8.6,12.4z"/>
	</g>
</g>
</svg>`;

const IconButtonMenuArrowLine = styled(IconButtonMenuArrowLineComponent)``;

export default IconButtonMenuArrowLine;
